import { motion } from "framer-motion";
import styled from "styled-components";
export const InitialAnimation = {
    hidden: { 
        opacity: 0,
        scale: 0.95,

    },
    show: {
        opacity: 1,
        scale: 1,
       
        transition: {
            duration: 1,
            when: "beforeChildren",
            staggerChildren: 0.2,
            staggerDirection: -1,
        }
    }
}

export const TimelineElementAnimation = {
    hidden: {
        opacity: 0,

    },
    show: {
        opacity: 1,
        
        
        transition: {
            duration: 3,
            
           
        }

    }
}

export const Hidden = styled.div`
    overflow: hidden;
`